import { Component, Input } from '@angular/core';
import { Address, Location, SimpleAddress } from '@queries/generated';

@Component({
  selector: 'vnm-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressComponent {
  @Input() address: Address | SimpleAddress;

  get province() {
    if (this.thingsIsLocation(this.address.province)) {
      return this.address.province.code;
    }
    return this.address.province;
  }

  get country() {
    if (this.thingsIsLocation(this.address.country)) {
      return this.address.country.code;
    }
    return this.address.country;
  }

  private thingsIsLocation(thing: string | Pick<Location, 'name' | 'code'>): thing is Location {
    if (typeof thing === 'string') {
      return false;
    }
    return true;
  }
}
